import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../App.css';

function Home() {
  const { isAuthenticated } = useAuth();
  return (
    <>
      <main className="main-content">
        <section className="hero">
          <h1>Find your calm, one entry at a time.</h1>
          <p>
            ZenLog is a minimal journaling platform that helps you reflect, grow, and stay present.
            Simple. Secure. Yours.
          </p>
          <div id="cta" className="cta-buttons">
            {isAuthenticated ? (
              <Link to="/dashboard" className="btn btn-primary">
                Dashboard
              </Link>
            ) : (
              <Link to="/signup" className="btn btn-primary">
                Get Started
              </Link>
            )}
            {isAuthenticated ? (
              <Link to="/analytics" className="btn btn-secondary">
                Analytics
              </Link>
            ) : (
              <a href="#features" className="btn btn-secondary">
                Learn more
              </a>
            )}
          </div>
        </section>

        <section id="features" className="features-section">
          <div className="features-grid">
            <FeatureCard title="Distraction-free" desc="A clean editor that lets your thoughts flow." iconClass="icon-accent-1" />
            <FeatureCard title="Private by Default" desc="Your entries stay yours. Supabase-backed journaling and local API calling for more insights." iconClass="icon-accent-2" />
            <FeatureCard title="Memories Analytics" desc="Track your mood, clearly see how your emotions change over time." iconClass="icon-accent-3" />
          </div>
        </section>
      </main>

    </>
  );
}

type FeatureCardProps = { title: string; desc: string; iconClass: string };

function FeatureCard({ title, desc, iconClass }: FeatureCardProps) {
  return (
    <div className="feature-card">
      <div className={`feature-icon ${iconClass}`} />
      <h3>{title}</h3>
      <p>{desc}</p>
    </div>
  );
}

export default Home;
